var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcoAppsGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96.7 100",
    style: {
      enableBackground: "new 0 0 96.7 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#005344;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50,21.7c-6,0-10.9-4.9-10.9-10.9S44,0,50,0c6,0,10.9,4.9,10.9,10.9C60.9,16.9,56,21.7,50,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.9,21.7c-6,0-10.9-4.9-10.9-10.9S79.9,0,85.9,0c6,0,10.9,4.9,10.9,10.9C96.7,16.9,91.9,21.7,85.9,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.9,21.7C4.9,21.7,0,16.9,0,10.9C0,4.9,4.9,0,10.9,0s10.9,4.9,10.9,10.9S16.9,21.7,10.9,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50,60.9c-6,0-10.9-4.9-10.9-10.9c0-6,4.9-10.9,10.9-10.9c6,0,10.9,4.9,10.9,10.9C60.9,56,56,60.9,50,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.9,60.9C79.9,60.9,75,56,75,50c0-6,4.9-10.9,10.9-10.9c6,0,10.9,4.9,10.9,10.9 C96.7,56,91.9,60.9,85.9,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.9,60.9C4.9,60.9,0,56,0,50c0-6,4.9-10.9,10.9-10.9S21.7,44,21.7,50C21.7,56,16.9,60.9,10.9,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50,100c-6,0-10.9-4.9-10.9-10.9S44,78.3,50,78.3c6,0,10.9,4.9,10.9,10.9C60.9,95.1,56,100,50,100z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.9,100c-6,0-10.9-4.9-10.9-10.9s4.9-10.9,10.9-10.9c6,0,10.9,4.9,10.9,10.9C96.7,95.1,91.9,100,85.9,100z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.9,100C4.9,100,0,95.1,0,89.1s4.9-10.9,10.9-10.9s10.9,4.9,10.9,10.9S16.9,100,10.9,100z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAppsGreen);
export default __webpack_public_path__ + "static/media/ico-apps-green.abd689866194f7dfb7ac08920b8db494.svg";
export { ForwardRef as ReactComponent };